import { createTheme } from "@mui/material";
import { Theme } from '@mui/material/styles';
import { plPL } from "@mui/material/locale";

declare module '@mui/styles' {
    interface DefaultTheme extends Theme {
    }
}

declare module '@mui/material/Button' {
    interface ButtonPropsVariantOverrides {
        outlinederror: true;
    }
}

const baseTheme = createTheme({
    typography: {
        fontSize: 13,
        h1: {
            fontSize: '1.7em',
            fontWeight: 'bold'
        },
        h2: {
            fontSize: '1.5em',
            fontWeight: 'bold'
        },
        h3: {
            fontSize: '1.4em',
            fontWeight: 'bold'
        },
        h4: {
            fontSize: '1.3em',
            fontWeight: 'bold'
        },
        h5: {
            fontSize: '1.2em',
            fontWeight: 'bold'
        },
        h6: {
            fontSize: '1.0em',
            fontWeight: 'bold'
        },
    },

    palette: {
        primary: {
            light: '#f2fafe',
            main: '#287EA6',
            dark: '#0B4560',
            contrastText: '#ffffff'
        },
        secondary: {
            light: '#efb56b',
            main: '#F69F2B',
            contrastText: '#ffffff'
        },
        text: {
            primary: '#222222',
            secondary: '#F69F2B',
        },
        error: {
            main: '#b01212',
            light: '#a82828',
            dark: '#a10707',
        },
        success: {
            main: '#069b32',
            light: 'rgba(22,215,74,0.21)',
            dark: '#046721',
        }
    },

    components: {
        MuiTableCell: {
            defaultProps: {
                sx: {
                    border: '1px solid #EBEBEB',
                    padding: '8px'
                },
            }
        },
        MuiListItemIcon: {
            defaultProps: {
                sx: {
                    minWidth: '40px'
                }
            },
        },
        MuiIconButton: {
            styleOverrides: {
                sizeSmall: {
                    fontSize: '12px'
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff'
                },
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                asterisk: {
                    color: '#D52928'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                outlined: {
                    backgroundColor: '#ffffff'
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    maxWidth: '80%',
                    width: 'auto'
                }
            }
        },
        MuiCheckbox: {
            defaultProps: {
                sx: {
                    paddingTop: 0,
                    paddingBottom: 0,
                }
            }
        },
        MuiRadio: {
            defaultProps: {
                sx: {
                    paddingTop: 0,
                    paddingBottom: 0,
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    maxWidth: 'none',
                    padding: 0,
                    border: '1px solid lightgrey',
                },
                arrow: {
                    color: '#ededed',
                    "&:before": {
                        border: '1px solid lightgrey'
                    },
                }
            }
        },

        // MuiTab: {
        //     '& .Mui-selected': {
        //         color: 'red !important',
        //     },
        //     color: 'red !important',
        //     paddingTop: '0 !important',
        //     paddingBottom: '0 !important',
        //     fontSize: '12px !important',
        //     minHeight: '52px !important',
        //     height: '52px !important'
        // },

    }
}, plPL);

const theme = createTheme(baseTheme, {
    components: {
        MuiChip: {
            styleOverrides: {
                deleteIcon: {
                    color: baseTheme.palette.primary.contrastText
                }
            },
            defaultProps: {
                sx: {
                    backgroundColor: baseTheme.palette.primary.main,
                    color: baseTheme.palette.primary.contrastText,
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                formControl: {
                    color: baseTheme.palette.grey.A700
                }
            }
        },
        MuiTextField: {
            styleOverrides: {},
            variants: [
                {
                    props: { variant: 'filled' },
                    style: {
                        '& .MuiInputBase-root': {
                            backgroundColor: baseTheme.palette.primary.light
                        }
                    }
                }
            ]
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    color: baseTheme.palette.grey.A700
                }
            }
        },
        MuiButton: {
            variants: [
                {
                    props: { variant: 'outlined' },
                    style: {
                        // minWidth: '110px !important',
                        // color: baseTheme.palette.secondary.main,
                        // borderColor: baseTheme.palette.secondary.main,
                    },
                },
            ]
        },
        MuiTab: {
            defaultProps: {
                sx: {
                    '&.Mui-selected': {
                        color: baseTheme.palette.secondary.main + ' !important',
                    },
                    color: baseTheme.palette.primary.main + ' !important',
                    paddingTop: '0 !important',
                    paddingBottom: '0 !important',
                    fontSize: '12px !important',
                    minHeight: '52px !important',
                    height: '52px !important'
                }
            }
        },
        MuiTabs: {
            defaultProps: {
                sx: {
                    '& .MuiTabs-indicator': {
                        backgroundColor: baseTheme.palette.secondary.main + ' !important',
                    },
                    height: '52px !important'
                }
            }
        }
    }
})

export default theme;